import DataQuery from 'data/DataQuery';
import { Dashboard_Requirements } from 'data/endpoints';
import { useQuery } from 'data/hooks/useQuery';
import RequirementSimplifiedDTO from 'features/requirements/dtos/RequirementSimplifiedDTO';
import { Dashboard_RequirementsCard } from 'features/shared/components/loaders/promiseLoadingAreas';
import { getRouteParams } from 'features/shared/helpers/routeParams';
import CustomerState from 'infrastructure/store/customer/CustomerState';
import IAppState from 'infrastructure/store/IAppState';
import React from 'react';
import { useSelector } from 'react-redux';
import { getQueryParams } from 'features/shared/helpers/queryParams';
import DashboardSectionProps from 'features/dashboard/models/DashboardSectionProps';
import DashboardListingCard from 'features/dashboard/components/DashboardListingCard';
import RequirementDashboardRow from 'features/requirements/components/RequirementDashboardRow';
import { useTranslation } from 'react-i18next';

const DashboardRequirementsSection = (props: DashboardSectionProps) => {
  // translations
  const t = useTranslation("dashboard\\dashboard").t;

  // private props
  const itemsCount = props.itemsCount ?? 4;

  // store
  const customer = (useSelector<IAppState, CustomerState>((store) => store.customer)).customer;

  // fetch data
  const contractCountsQuery: DataQuery = {
    url: Dashboard_Requirements,
    routeParams: getRouteParams("customerId", customer.customerId!),
    params: getQueryParams("Count", itemsCount.toString())
  };
  const { data, loadStatus } = useQuery<RequirementSimplifiedDTO[]>(contractCountsQuery, [], [customer], {
    useTracker: true,
    area: Dashboard_RequirementsCard,
  });

  // render
  return (
    <DashboardListingCard 
      title={t(`dashboardItems.${props.title}`)}
      items={data}
      renderItem={(item) => <RequirementDashboardRow requirement={item} />}
      itemsLoadStatus={loadStatus}
      moduleRoute="/requirements"
      background={props.background}
      icon={props.icon}
      iconColor={props.iconColor}
      count={itemsCount}
      loaderArea={Dashboard_RequirementsCard}
    />
  );
}

export default DashboardRequirementsSection;
